// extracted by mini-css-extract-plugin
export var innerContent = "CardSideNav_innerContent__mY72q";
export var rotate = "CardSideNav_rotate__Pfko1";
export var dotty = "CardSideNav_dotty__gQji9";